import { ApplicationConfig, importProvidersFrom, APP_INITIALIZER, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { studioAuthInterceptor } from './core/interceptors/auth.interceptor';

function savedLanguage(): 'ar' | 'en' {
  try {
    const v = localStorage.getItem('manarah-studio-lang');
    return v === 'en' ? 'en' : 'ar';
  } catch {
    return 'ar';
  }
}

function initializeTranslations(translate: TranslateService) {
  return async () => {
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('ar');
    await firstValueFrom(translate.use(savedLanguage()));
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([studioAuthInterceptor])),
    importProvidersFrom(TranslateModule.forRoot({ defaultLanguage: savedLanguage() })),
    provideTranslateHttpLoader({ prefix: '/assets/i18n/', suffix: '.json' }),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeTranslations,
      deps: [TranslateService],
      multi: true
    }
  ]
};
